(ns minorodata.connections.list
  (:require [cljs.spec.alpha :as spec]
            [goog.string :as goog.string]
            [minorodata.app.utils :as app.utils]
            [minorodata.connections.sources.list :as sources.list]
            [mold-forms.core :as form-component]
            [spec-tools.core :as st]))


(def aws-regions
  [{:name "EU (Frankfurt)"             :value "eu-central-1"}
   {:name "EU (Stockholm)"             :value "eu-north-1"}
   {:name "EU (Ireland)"               :value "eu-west-1"}
   {:name "EU (London)"                :value "eu-west-2"}
   {:name "EU (Paris)"                 :value "eu-west-3"}
   {:name "EU (Milan)"                 :value "eu-south-1"}
   {:name "US East (N. Virginia)"      :value "us-east-1"}
   {:name "US East (Ohio)"             :value "us-east-2"}
   {:name "US West (N. California)"    :value "us-west-1"}
   {:name "US West (Oregon)"           :value "us-west-2"}
   {:name "Asia Pacific (Mumbai)"      :value "ap-south-1"}
   {:name "Asia Pacific (Hong Kong)"   :value "ap-east-1"}
   {:name "Asia Pacific (Tokyo)"       :value "ap-northeast-1"}
   {:name "Asia Pacific (Seoul)"       :value "ap-northeast-2"}
   {:name "Asia Pacific (Osaka-Local)" :value "ap-northeast-3"}
   {:name "Asia Pacific (Singapore)"   :value "ap-southeast-1"}
   {:name "Asia Pacific (Sydney)"      :value "ap-southeast-2"}
   {:name "Asia Pacific (Jakarta)"     :value "ap-southeast-3"}
   {:name "Africa (Cape Town)"         :value "af-south-1"}
   {:name "China (Beijing)"            :value "cn-north-1"}
   {:name "China (Ningxia)"            :value "cn-northwest-1"}
   {:name "Canada (Central)"           :value "ca-central-1"}
   {:name "Middle East (Bahrain)"      :value "me-south-1"}
   {:name "South America (Sao Paulo)"  :value "sa-east-1"}])


(def bq-regions
  [{:name "Columbus, Ohio"    :value "us-east5"}
   {:name "Dallas"            :value "us-south1"}
   {:name "Iowa"              :value "us-central1"}
   {:name "Las Vegas"         :value "us-west4"}
   {:name "Los Angeles"       :value "us-west2"}
   {:name "Montréal"          :value "northamerica-northeast1"}
   {:name "Northern Virginia" :value "us-east4"}
   {:name "Oregon"            :value "us-west1"}
   {:name "Salt Lake City"    :value "us-west3"}
   {:name "São Paulo"         :value "southamerica-east1"}
   {:name "Santiago"          :value "southamerica-west1"}
   {:name "South Carolina"    :value "us-east1"}
   {:name "Toronto"           :value "northamerica-northeast2"}
   {:name "Delhi"             :value "asia-south2"}
   {:name "Hong Kong"         :value "asia-east2"}
   {:name "Jakarta"           :value "asia-southeast2"}
   {:name "Melbourne"         :value "australia-southeast2"}
   {:name "Mumbai"            :value "asia-south1"}
   {:name "Osaka"             :value "asia-northeast2"}
   {:name "Seoul"             :value "asia-northeast3"}
   {:name "Singapore"         :value "asia-southeast1"}
   {:name "Sydney"            :value "australia-southeast1"}
   {:name "Taiwan"            :value "asia-east1"}
   {:name "Tokyo"             :value "asia-northeast1"}
   {:name "Belgium"           :value "europe-west1"}
   {:name "Berlin"            :value "europe-west10"}
   {:name "Finland"           :value "europe-north1"}
   {:name "Frankfurt"         :value "europe-west3"}
   {:name "London"            :value "europe-west2"}
   {:name "Madrid"            :value "europe-southwest1"}
   {:name "Milan"             :value "europe-west8"}
   {:name "Netherlands"       :value "europe-west4"}
   {:name "Paris"             :value "europe-west9"}
   {:name "Turin"             :value "europe-west12"}
   {:name "Warsaw"            :value "europe-central2"}
   {:name "Zürich"            :value "europe-west6"}
   {:name "Dammam"            :value "me-central2"}
   {:name "Doha"              :value "me-central1"}
   {:name "Tel Aviv"          :value "me-west1"}
   {:name "Johannesburg"      :value "africa-south1"}
   {:name "European Union1"   :value "EU"}
   {:name "United States"     :value "US"}])

(defn format-region-option-names [regions]
  (map (fn [{:keys [name value]}]
         {:name (str name ", " value)
          :value value})
       regions))


(defn url-encode [s]
  (goog.string/urlEncode s))


(defn url-decode [s]
  (goog.string/urlDecode s))


(def aws-region-options
  (concat [{:name "" :value nil}]
          (format-region-option-names aws-regions)))


(def bq-region-options
  (concat [{:name "" :value nil}]
          (format-region-option-names bq-regions)))


(def sources
  sources.list/all)

(defn get-file-json [file-data]
  (let [content (get file-data :content)]
    (try
      (-> (js/JSON.parse content)
          (js->clj :keywordize-keys true))
      (catch js/Error _e
        ;; return content as it is if it's not a valid JSON
        content))))

(defn add-store-data [warehouse]
  (let [json-data (get-file-json (:bigquery-json warehouse))]
    (assoc warehouse
           :client-email   (:client_email json-data)
           :client-id      (:client_id json-data)
           :private-key-id (:private_key_id json-data)
           :project-id     (:project_id json-data)
           :private-key    (:private_key json-data))))

(defn bq-format-for-api [warehouse]
  {:button     "save"
   :sink-type  "bigquery"
   :store-type "google-cloud-storage"
   :json-data  (add-store-data warehouse)})


(defn bq-format-for-input [data]
  ;; this logic is repeated also later
  {:store-type     "google-cloud-storage" ;; BigQuery works only with GCS
   :client-email   (:filestore-data/client-email data)
   :client-id      (:filestore-data/client-id data)
   :private-key    (:filestore-data/private-key data)
   :private-key-id (:filestore-data/private-key-id data)
   :project-id     (:filestore-data/project-id data)
   :bucket         (:filestore-data/bucket data)
   :region         (get-in data [:warehouse-data/json-data :region])
   :bigquery-json  (get-in data [:warehouse-data/json-data :bigquery-json])
   :filestore-requires-ip-whitelist (:filestore-data/filestore-requires-ip-whitelist data)})

(spec/def ::bigquery-json
  (spec/and (st/spec some? {:reason "Please provide a file with warehouse configuration"})))

(spec/def ::bigquery-connection-form
  (spec/and
   (spec/keys :req-un [::bigquery-json])))

(def big-query
  {:id "bigquery"
   :enabled true
   :name "Google BigQuery"
   :image-source "bigquery.png"

   :form {:format-for-api    bq-format-for-api
          ;; can we have some read only fields that display the whole thing?
          ;; or maybe a download-json button to download the current configuration?
          :format-for-inputs bq-format-for-input
          :id                :warehouse-big-query-form

          :validate          (partial form-component/validate-form ::bigquery-connection-form)
          :blocks
          [{:block-type :subtitle
            :content     "Warehouse configuration"}

           {:block-type :file-input
            :label      "bigquery configuration"
            :name       :bigquery-json}

           {:block-type :select
            :label      "Default Region"
            :name       :region
            :required   true
            :options    bq-region-options
            :value      ""}

           {:block-type :subtitle
            :content    "Filestore configuration"}

           {:block-type :select
            :label      "Filestore type"
            :disabled   true
            :name       :store-type
            :required   true
            :options    [{:value "google-cloud-storage" :name "Google Cloud storage"}]
            :value      "google-cloud-storage"}

           {:block-type :input
            :label      "Client Email"
            :disabled   true
            :name       :client-email
            :value      ""
            :conditions [[:not-nil [:client-email :value]]]}

           {:block-type :input
            :label      "Default Bucket"
            :name       :bucket
            :required   true
            :value      ""}

           {:block-type :checkbox
            :label      "Requires IP whitelisting"
            :name       :filestore-requires-ip-whitelist
            :value      false
            :type       :checkbox}

           {:block-type :warehouse-status
            :name       :warehouse-status}

           {:block-type :submit
            :content    "SAVE"}]}})


(def redshift
  {:id           "redshift"
   :enabled      true
   :name         "Amazon Redshift"
   :image-source "redshift.png"
   :form         {:format-for-api    (fn [warehouse]
                                       (let [{:keys [has-bastion? bastion-hostname bastion-user private-key]} warehouse
                                             warehouse   (-> warehouse
                                                             (update :db-password url-encode)
                                                             (dissoc :bastion-hostname
                                                                     :bastion-user
                                                                     :private-key))]
                                         {:button    "save"
                                          :sink-type "redshift"
                                          :json-data (cond-> (assoc warehouse :store-type "s3")
                                                       (and has-bastion?
                                                            (every? some? [bastion-hostname
                                                                           bastion-user
                                                                           private-key]))
                                                       (assoc :bastion {:host        bastion-hostname
                                                                        :user        bastion-user
                                                                        :private-key private-key}))}))

                  :format-for-inputs (fn [data]
                                       (let [{warehouse-json :warehouse-data/json-data} data

                                             bastion (:bastion warehouse-json)

                                             {:keys [host user private-key]} bastion

                                             has-bastion?   (if (some some? (keys bastion))
                                                              true
                                                              false)

                                             db-password    (get warehouse-json :db-password)
                                             db-password'   (when db-password
                                                              (url-decode db-password))

                                             warehouse-json (assoc warehouse-json :db-password db-password')]
                                         (merge warehouse-json
                                                {:store-type     "s3" ;; Redshfit only supports s3
                                                 :s3-key         (:filestore-data/s3-key data)
                                                 :s3-secret      (:filestore-data/s3-secret data)
                                                 :s3-region      (:filestore-data/region data)
                                                 :bucket         (:filestore-data/bucket data)
                                                 :url            (:filestore-data/url data)
                                                 :sas-token      (:filestore-data/sas-token data)
                                                 :container-name (:filestore-data/container-name data)
                                                 :filestore-requires-ip-whitelist (:filestore-data/filestore-requires-ip-whitelist data)
                                                 :has-bastion?     has-bastion?
                                                 :bastion-hostname host
                                                 :bastion-user     user
                                                 :private-key      private-key})))

                  :id                :warehouse-redshift-form

                  :blocks            [{:block-type :input
                                       :label      "Host"
                                       :name       :host
                                       :required   true
                                       :value      ""}
                                      {:block-type :input
                                       :label      "Port"
                                       :name       :port
                                       :required   true
                                       :type       :number
                                       :value      ""}
                                      {:block-type :input
                                       :label      "Database Name"
                                       :name       :db-name
                                       :required   true
                                       :value      ""}
                                      {:block-type :input
                                       :label      "Database User"
                                       :name       :db-user
                                       :required   true
                                       :value      ""}
                                      {:block-type :input
                                       :label      "Database Password"
                                       :name       :db-password
                                       :type       :password
                                       :required   true
                                       :value      ""}
                                      {:block-type :input
                                       :label      "IAM Role"
                                       :name       :aws-iam-role
                                       :value      ""}

                                      {:block-type :checkbox
                                       :label      "Requires SSL"
                                       :name       :require-ssl
                                       :type       :checkbox
                                       :value      false}

                                      {:block-type :checkbox
                                       :label      "Requires IP Whitelisting"
                                       :name       :require-ip-whitelist
                                       :type       :checkbox
                                       :value      false}

                                      {:block-type :checkbox
                                       :label      "Requires tunneling"
                                       :name       :has-bastion?
                                       :type       :checkbox
                                       :value      false}

                                      {:block-type :subtitle
                                       :content    "Bastion host"
                                       :conditions [[:eq [:has-bastion? :value] true]]}

                                      {:block-type    :input
                                       :label         "Bastion Hostname"
                                       :name          :bastion-hostname
                                       :required      true
                                       :value         ""
                                       :default-value ""
                                       :conditions [[:eq [:has-bastion? :value] true]]}

                                      {:block-type    :input
                                       :label         "Bastion User"
                                       :name          :bastion-user
                                       :value         ""
                                       :default-value ""
                                       :required      true
                                       :conditions    [[:eq [:has-bastion? :value] true]]}

                                      {:block-type :file-input
                                       :label      "Private key file"
                                       :name       :private-key
                                       :required   true
                                       :conditions [[:eq [:has-bastion? :value] true]]}

                                      {:block-type :subtitle
                                       :content    "Filestore configuration"}

                                      {:block-type :select
                                       :label      "Filestore type"
                                       :disabled   true
                                       :name       :store-type
                                       :required   true
                                       :options [{:value "s3" :name "Amazon S3"}]
                                       :value "s3"}

                                      {:block-type :input
                                       :label      "AWS Access Key"
                                       :name       :s3-key
                                       :required   true
                                       :value      ""}
                                      {:block-type :input
                                       :label      "AWS Secret Access Key"
                                       :name       :s3-secret
                                       :type       :password
                                       :required   true
                                       :value      ""}
                                      {:block-type :select
                                       :label      "AWS S3 Region"
                                       :name       :s3-region
                                       :required   true
                                       :options    aws-region-options
                                       :value      ""}
                                      {:block-type :input
                                       :label      "Default Bucket"
                                       :name       :bucket
                                       :required   true
                                       :value      ""}
                                      {:block-type :checkbox
                                       :label      "Requires IP whitelisting"
                                       :name       :filestore-requires-ip-whitelist
                                       :value      false
                                       :type       :checkbox}

                                      {:block-type :warehouse-status
                                       :name       :warehouse-status}

                                      {:block-type :submit
                                       :content    "SAVE"}]}})


(defn add-gcs-blob
  "This is something kioku expects
  https://github.com/Minoro-Ltd/minoro.kioku/blob/19b4835536a6d8435b4d495fb96af5b73c65d1dd/src/kioku/handlers/sources.clj#L515"
  [warehouse-data]
  (let [gcs-config (select-keys warehouse-data [:client_email :client_id :private_key :private_key_id :project_id])
        gcs-config-string (.stringify js/JSON (clj->js gcs-config))]
    (assoc-in warehouse-data [:bigquery-json :content] gcs-config-string)))


(def snowflake
  {:id           "snowflake"
   :enabled      true
   :name         "Snowflake"
   :image-source "snowflake.png"
   :form         {:format-for-api    (fn [warehouse]
                                       (let [auth (:authentication warehouse)
                                             store-type (:store-type warehouse)]
                                         {:button    "save"
                                          :sink-type "snowflake"
                                          :json-data (cond-> (dissoc warehouse :authentication)
                                                       (= auth "basic")    (dissoc :private-key :passphrase)
                                                       (= auth "key-pair") (dissoc :db-password)
                                                       (= store-type "google-cloud-storage") add-gcs-blob)}))

                  :format-for-inputs (fn [data]
                                       (let [{warehouse-json :warehouse-data/json-data} data]
                                         (merge warehouse-json
                                                (app.utils/keep-non-nil-keys
                                                 {:store-type     (:store-type data)
                                                  :s3-key         (:filestore-data/s3-key data)
                                                  :s3-secret      (:filestore-data/s3-secret data)
                                                  :s3-region      (:filestore-data/region data)
                                                  :bucket         (:filestore-data/bucket data)
                                                  :url            (:filestore-data/url data)
                                                  :sas-token      (:filestore-data/sas-token data)
                                                  :container-name (:filestore-data/container-name data)

                                                  :filestore-requires-ip-whitelist
                                                  (:filestore-data/filestore-requires-ip-whitelist data)

                                                  :client_email   (:filestore-data/client-email data)
                                                  :client_id      (:filestore-data/client-id data)
                                                  :private_key    (:filestore-data/private-key data)
                                                  :private_key_id (:filestore-data/private-key-id data)
                                                  :project_id     (:filestore-data/project-id data)

                                                  :authentication (if (:private-key warehouse-json) "key-pair" "basic")}))))

                  :id                :snowflake-warehouse-form

                  :blocks            [{:block-type :input
                                       :label      "Host name"
                                       :name       :host
                                       :required   true
                                       :value      ""}
                                      {:block-type :input
                                       :label      "Database Name"
                                       :name       :db-name
                                       :required   true
                                       :value      ""}
                                      {:block-type :input
                                       :label      "Warehouse Name"
                                       :name       :warehouse-name
                                       :required   true
                                       :value      ""}

                                      {:block-type :input
                                       :label      "Role"
                                       :name       :role
                                       :required   true
                                       :value      ""}
                                      {:block-type :input
                                       :label      "Database User"
                                       :name       :db-user
                                       :required   true
                                       :value      ""}

                                      {:block-type :select
                                       :label      "Authentication"
                                       :value      "basic"
                                       :name       :authentication
                                       :options    [{:value "basic" :name "Basic Auth"}
                                                    {:value "key-pair" :name "Key Pair"}]}

                                      {:block-type :input
                                       :label      "Database Password"
                                       :name       :db-password
                                       :type       :password
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:authentication :value] "basic"]]}

                                      {:block-type :alert
                                       :conditions [[:eq [:authentication :value] "key-pair"]]
                                       :title      "Warning"
                                       :content    "Using key pair authentication will remove database password from warehouse configuration."}

                                      {:block-type :input
                                       :label      "Private Key"
                                       :name       :private-key
                                       :required   true
                                       :multiline  true
                                       :controlled true
                                       :value      ""
                                       :conditions [[:eq [:authentication :value] "key-pair"]]}

                                      {:block-type :input
                                       :label      "Private Key Passphrase"
                                       :name       :passphrase
                                       :type       :password
                                       :controlled true
                                       :value      ""
                                       :conditions [[:eq [:authentication :value] "key-pair"]]}

                                      {:block-type :generate-keypair
                                       :name       :generate-keypair
                                       :conditions [[:eq [:authentication :value] "key-pair"]]}

                                      {:block-type :checkbox
                                       :label      "Use separate warehouse for extracts"
                                       :name       :use-extracts-warehouse?
                                       :type       :checkbox
                                       :value      false
                                       :conditions [[:eq [:kleene-globals :multi-warehouse?] true]]}

                                      {:block-type :input
                                       :label      "Extracts Warehouse Name"
                                       :name       :extracts-warehouse-name
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:use-extracts-warehouse? :value] true]]}

                                      {:block-type :input
                                       :label      "Extracts Role"
                                       :name       :extracts-role
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:use-extracts-warehouse? :value] true]]}

                                      {:block-type :input
                                       :label      "Extracts Database User"
                                       :name       :extracts-db-user
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:use-extracts-warehouse? :value] true]]}

                                      {:block-type :select
                                       :label      "Extracts Warehouse Authentication"
                                       :value      "basic"
                                       :name       :extracts-authentication
                                       :options    [{:value "basic" :name "Basic Auth"}
                                                    {:value "key-pair" :name "Key Pair"}]
                                       :conditions [[:eq [:use-extracts-warehouse? :value] true]]}

                                      {:block-type :input
                                       :label      "Extracts Database Password"
                                       :name       :extracts-db-password
                                       :type       :password
                                       :required   true
                                       :value      ""
                                       :conditions [[:and
                                                     [[:use-extracts-warehouse? :value]
                                                      [:extracts-authentication :value]]
                                                     [true "basic"]]]}

                                      {:block-type :alert
                                       :conditions [[:and
                                                     [[:use-extracts-warehouse? :value]
                                                      [:extracts-authentication :value]]
                                                     [true "key-pair"]]]
                                       :title      "Warning"
                                       :content    "Using key pair authentication will remove database password from extracts warehouse configuration."}

                                      {:block-type :input
                                       :label      "Private Key"
                                       :name       :extracts-private-key
                                       :required   true
                                       :multiline  true
                                       :controlled true
                                       :value      ""
                                       :conditions [[:and
                                                     [[:use-extracts-warehouse? :value]
                                                      [:extracts-authentication :value]]
                                                     [true "key-pair"]]]}

                                      {:block-type :input
                                       :label      "Private Key Passphrase"
                                       :name       :extracts-passphrase
                                       :type       :password
                                       :controlled true
                                       :value      ""
                                       :conditions [[:and
                                                     [[:use-extracts-warehouse? :value]
                                                      [:extracts-authentication :value]]
                                                     [true "key-pair"]]]}

                                      {:block-type :checkbox
                                       :label      "Requires IP Whitelisting"
                                       :name       :require-ip-whitelist
                                       :type       :checkbox
                                       :value      false}

                                      {:block-type :input
                                       :label      "Storage Integration"
                                       :name       :storage-integration
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "google-cloud-storage"]]}

                                      {:block-type :subtitle
                                       :content    "Unit tests configuration"}

                                      {:block-type :alert
                                       :title      "Warning"
                                       :content    "Unit tests use the default database/schema configuration unless set differently. Changing this setting does not update existing unit tests automatically, so they must be reviewed individually."}

                                      {:block-type :input
                                       :label      "Results table catalog"
                                       :name       :dut-db
                                       :placeholder "PROD"
                                       :conditions [[:eq [:kleene-globals :sink-type] "snowflake"]]}

                                      {:block-type :input
                                       :label      "Results table schema"
                                       :name       :dut-schema
                                       :placeholder "KLEENE"}

                                      {:block-type :subtitle
                                       :content    "Filestore configuration"}

                                      {:block-type :select
                                       :label      "Filestore type"
                                       :name       :store-type
                                       :required   true
                                       :options    [{:value "s3" :name "Amazon S3"}
                                                    {:value "azure-blob" :name "Azure Blob Storage"}
                                                    {:value "google-cloud-storage" :name "Google Cloud storage"}]
                                       :value "s3"}

                                      ;; Settings for Azure

                                      {:block-type :input
                                       :label      "Azure container url"
                                       :name       :url
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "azure-blob"]]}

                                      {:content "Please use container URL without protocol (remove leading https:// or azure://)"
                                       :conditions [[:eq [:store-type :value] "azure-blob"]]}

                                      {:block-type :input
                                       :label      "SAS token"
                                       :name       :sas-token
                                       :type       :password
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "azure-blob"]]}
                                      {:block-type :input
                                       :label      "Default container name"
                                       :name       :container-name
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "azure-blob"]]}

                                      {:block-type :checkbox
                                       :label      "Requires IP whitelisting"
                                       :name       :filestore-requires-ip-whitelist
                                       :value      false
                                       :type       :checkbox
                                       :conditions [[:eq [:store-type :value] "azure-blob"]]}

                                      ;; Settings for S3

                                      {:block-type :input
                                       :label      "AWS Access Key ID"
                                       :name       :s3-key
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "s3"]]}
                                      {:block-type :input
                                       :label      "AWS Secret Access Key"
                                       :name       :s3-secret
                                       :type       :password
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "s3"]]}
                                      {:block-type :select
                                       :label      "AWS S3 Region"
                                       :name       :s3-region
                                       :required   true
                                       :options    aws-region-options
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "s3"]]}
                                      {:block-type :input
                                       :label      "Default Bucket"
                                       :name       :bucket
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "s3"]]}

                                      {:block-type :checkbox
                                       :label      "Requires IP whitelisting"
                                       :name       :filestore-requires-ip-whitelist
                                       :value      false
                                       :type       :checkbox
                                       :conditions [[:eq [:store-type :value] "s3"]]}

                                      ;; Settings for Google Cloud Storage

                                      {:block-type :input
                                       :label      "Client Email"
                                       :name       :client_email
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "google-cloud-storage"]]}

                                      {:block-type :input
                                       :label      "Client ID"
                                       :name       :client_id
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "google-cloud-storage"]]}

                                      {:block-type :input
                                       :label      "Private Key"
                                       :name       :private_key
                                       :type       :password
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "google-cloud-storage"]]}

                                      {:block-type :input
                                       :label      "Private Key ID"
                                       :name       :private_key_id
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "google-cloud-storage"]]}

                                      {:block-type :input
                                       :label      "Project ID"
                                       :name       :project_id
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "google-cloud-storage"]]}

                                      {:block-type :input
                                       :label      "Default Bucket"
                                       :name       :bucket
                                       :required   true
                                       :value      ""
                                       :conditions [[:eq [:store-type :value] "google-cloud-storage"]]}

                                      {:block-type :checkbox
                                       :label      "Requires IP whitelisting"
                                       :name       :filestore-requires-ip-whitelist
                                       :value      false
                                       :type       :checkbox
                                       :conditions [[:eq [:store-type :value] "google-cloud-storage"]]}

                                      {:block-type :warehouse-status
                                       :name       :warehouse-status}

                                      {:block-type :submit
                                       :content    "SAVE"}]}})

(def warehouses
  [big-query
   redshift
   snowflake])


(def filestores
  [{:id           "s3"
    :enabled      true
    :name         "S3"
    :image-source "s3.png"}
   {:id           "azure-blob"
    :enabled      true
    :name         "Azure Blob Storage"
    :image-source "azure-blob.png"}
   {:id           "google-cloud-storage"
    :enabled      true
    :name         "Google Cloud Storage"
    :image-source "google-cloud-storage.png"}])
